var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"type":_vm.type,"variant":_vm.variant,"size":_vm.size,"disabled":_vm.isDisabled,"block":_vm.block},on:{"click":_vm.clicked}},[(_vm.isLoading)?_c('b-spinner',{staticClass:"mx-1",attrs:{"small":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }